// Determine base URL dynamically
const dynamicBaseURL =
    // If build-time env provided, use it
    (import.meta as any).env?.VITE_API_URL ||
    // Else fallback to same-origin backend
    `${window.location.protocol}//${window.location.host}/api`;

// API Configuration
export const API_CONFIG = {
    // Development settings
    development: {
        baseURL: (import.meta as any).env?.VITE_API_URL || 'http://localhost:5001/api',
        timeout: 10000,
    },

    // Production settings – use dynamic URL that works on any host/port
    production: {
        baseURL: dynamicBaseURL,
        timeout: 30000,
    },

    // Get current environment
    getCurrentConfig() {
        const isProduction = window.location.protocol === 'https:' ||
            (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1');

        return isProduction ? this.production : this.development;
    },

    // Get base URL for current environment
    getBaseURL() {
        return this.getCurrentConfig().baseURL;
    },

    // Get timeout for current environment
    getTimeout() {
        return this.getCurrentConfig().timeout;
    }
};

// Export current config for easy access
export const currentConfig = API_CONFIG.getCurrentConfig();
export const API_BASE_URL = API_CONFIG.getBaseURL();
